import script from "./MenuMobile.vue?vue&type=script&setup=true&lang=ts"
export * from "./MenuMobile.vue?vue&type=script&setup=true&lang=ts"

import "./MenuMobile.vue?vue&type=style&index=0&id=0732b3ea&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0732b3ea"]])

export default __exports__